import { Popover } from "lib/miolo";
import type { ReactElement } from "react";
import { forwardRef, useState } from "react";
import * as React from "react";
import * as palette from "../palette";

interface ICommentActionsDropdownChildrenState {
  closeOnClick: (onClick: () => void) => () => void;
}

interface ICommentActionsDropdownProps {
  children: (state: ICommentActionsDropdownChildrenState) => ReactElement;
}

export default function CommentActionsDropdown({ children }: ICommentActionsDropdownProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Popover
      id="RootCommentActions"
      isOpen={isOpen}
      arrowColor="transparent"
      backgroundColor={palette.white}
      onClose={() => setIsOpen(false)}
      containerStyle={{
        zIndex: 9999,
      }}
      render={({ onClose }) => {
        return children({
          closeOnClick: (onClick) => {
            return () => {
              if (onClick && typeof onClick === "function") {
                onClick();
                onClose();
              }
            };
          },
        });
      }}
    >
      {({ accessibility, ref }) => <DotdotdotButton {...accessibility} onClick={() => setIsOpen(!isOpen)} ref={ref} />}
    </Popover>
  );
}

const DotdotdotButton = forwardRef((props: React.HTMLAttributes<HTMLButtonElement>, ref: React.Ref<any>) => {
  return (
    <button
      {...props}
      type="button"
      ref={ref}
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        margin: 0,
        padding: 4,
        color: palette.heather,
        backgroundColor: "transparent",
        border: "solid 1px transparent",
        borderRadius: 4,
        outline: "none",
        cursor: "pointer",
        "&:hover": {
          color: palette.lynch,
          backgroundColor: palette.catskillWhite,
        },
        "&:focus": {
          backgroundColor: palette.catskillWhite,
          border: `solid 1px ${palette.cornflowerBlue}`,
          boxShadow: `0 0 0 3px ${palette.tropicalBlue}`,
        },
      }}
    >
      {/* ellipsis icon */}
      <svg width={29} height={7} viewBox="0 0 29 7">
        <path
          d="M18.056 3.5c0 1.932-1.593 3.5-3.556 3.5s-3.556-1.568-3.556-3.5S12.537 0 14.5 0s3.556 1.568 3.556 3.5zM25.444 0c-1.964 0-3.557 1.568-3.557 3.5S23.48 7 25.444 7C27.407 7 29 5.432 29 3.5S27.407 0 25.444 0zM3.556 0C1.593 0 0 1.568 0 3.5S1.593 7 3.556 7C5.52 7 7.113 5.432 7.113 3.5S5.52 0 3.556 0z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>
    </button>
  );
});
